<div class="contact-form-area">
  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12 mb-20">
        <div class="form-inner">
          <label data-translation-key="buyer_register_full_name">
            {{ 'buyer_register.full_name' | translate }}
            <span class="required"> * </span></label
            >
            <input
            [ngClass]="{
              'is-invalid':
                hasError('name', 'required') ||
                hasError('name', 'invalidFullName')
            }"
              class="input-field"
              type="text"
              placeholder="Daniel Scoot"
              formControlName="name"
              />
              @if (
                hasError('name', 'required') ||
                hasError('name', 'invalidFullName')
                ) {
                <mat-error
                  >
                  @if (hasError('name', 'required')) {
                    <span
                      class="error"
                      data-translation-key="buyer_register_full_name_required"
                      >
                      {{ 'buyer_register.full_name_required' | translate }}
                    </span>
                  }
                  @if (hasError('name', 'invalidFullName')) {
                    <span
                      class="error"
                      data-translation-key="buyer_register_full_name_validation"
                      >
                      {{ 'buyer_register.full_name_validation' | translate }}
                    </span>
                  }
                </mat-error>
              }
            </div>
          </div>
          <div class="col-md-6 mb-20">
            <div class="form-inner">
              <label data-translation-key="buyer_register_mobile_phone">
                {{ 'buyer_register.mobile_phone' | translate }}</label
                >
                <input
            [ngClass]="{
              'is-invalid': hasError('phone', 'pattern')
            }"
                  appNumbersOnly
                  type="text"
                  placeholder="+8801700000000"
                  class="input-field"
                  formControlName="phone"
                  />
                  @if (hasError('phone', 'pattern')) {
                    <mat-error>
                      @if (hasError('phone', 'pattern')) {
                        <span
                          class="error"
                          data-translation-key="buyer_register_phone_validation"
                          >
                          {{ 'buyer_register.phone_validation' | translate }}
                        </span>
                      }
                    </mat-error>
                  }
                </div>
              </div>
              <div class="col-md-6 mb-20">
                <div class="form-inner">
                  <label data-translation-key="buyer_register_email">{{ 'buyer_register.email' | translate }}</label>
                  <input
            [ngClass]="{
              'is-invalid': hasError('email', 'email')
            }"
                    class="input-field"
                    type="email"
                    placeholder="info@example.com"
                    formControlName="email"
                    />
                    @if (hasError('email', 'email')) {
                      <mat-error>
                        @if (hasError('email', 'email')) {
                          <span
                            class="error"
                            data-translation-key="buyer_register_email_invalid"
                            >
                            {{ 'buyer_register.email_invalid' | translate }}
                          </span>
                        }
                      </mat-error>
                    }
                  </div>
                </div>
                <div class="col-md-12 mb-30">
                  <div class="form-inner">
                    <label data-translation-key="buyer_register_write_your_message"
                      >{{ 'buyer_register.write_your_message' | translate }}
                      <span class="required"> * </span></label
                      >
                      <textarea
            [ngClass]="{
              'is-invalid':
                hasError('message', 'required') ||
                hasError('message', 'minlength')
            }"
                        class="input-field"
                        [placeholder]="'contact_us_form.buyer_register_what_s_on_your_mind' | translate"
                        formControlName="message"
                        data-translation-key="buyer_register_what_s_on_your_mind"
                      ></textarea>
                      @if (
                        hasError('message', 'required') ||
                        hasError('message', 'minlength')
                        ) {
                        <mat-error
                          >
                          @if (hasError('message', 'required')) {
                            <span
                              class="error"
                              data-translation-key="buyer_register_message_is_required"
                              >
                              {{ 'buyer_register.message_is_required' | translate }}
                            </span>
                          }
                          @if (hasError('message', 'minlength')) {
                            <span
                              class="error"
                              data-translation-key="buyer_register_message_validation"
                              >
                              {{ 'buyer_register.message_validation' | translate }}
                            </span>
                          }
                        </mat-error>
                      }
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-inner">
                      <button
                        class="primary-btn btn-hover"
                        type="submit"
                        [disabled]="isSubmitting"
                        [attr.data-translation-key]="'buyer_register_submit_now'"
                        >
                        {{ isSubmitting ? ('buyer_register.submitting' | translate) : ('buyer_register.submit_now' | translate) }}
                        <span></span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
